import { render } from "./ProductWishlistt.vue?vue&type=template&id=068a7ce3&scoped=true"
import script from "./ProductWishlistt.vue?vue&type=script&lang=js"
export * from "./ProductWishlistt.vue?vue&type=script&lang=js"

import "./ProductWishlistt.vue?vue&type=style&index=0&id=068a7ce3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068a7ce3"]])

export default __exports__